import AsyncStorage from "@react-native-async-storage/async-storage"
import { firestore, logger } from "capsule"
import ShortUniqueId from "short-unique-id"

import { collections } from "../../common/types"

const uid = new ShortUniqueId({ length: 10 })

const NEW_CLIENT_DOC_ID_KEY = "newClientDocId"

export const generateTempId = (): string => uid()

export const getNewClientDocId = async (): Promise<string | null> =>
  AsyncStorage.getItem(NEW_CLIENT_DOC_ID_KEY)

export const createNewClientDoc = async (initialData: Record<string, any>): Promise<string> => {
  const docId = generateTempId()

  await firestore()
    .collection(collections.NEW_CLIENT)
    .doc(docId)
    .set({
      ...initialData,
      createdAt: firestore.Timestamp.now(),
    })

  await AsyncStorage.setItem(NEW_CLIENT_DOC_ID_KEY, docId)

  return docId
}

export const updateNewClientData = async (docId: string | null, values: Record<string, any>) => {
  if (!docId) {
    logger("updateNewClientData: docId is null")
    return
  }

  await firestore().collection(collections.NEW_CLIENT).doc(docId).set(values, { merge: true })
}

export const clearNewClientDocId = async () => {
  await AsyncStorage.removeItem(NEW_CLIENT_DOC_ID_KEY)
}
